import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuxIconName } from '@shared/components/icon/icon';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MoneyPipe } from '@shared/pipes/money.pipe';

@Component({
  imports: [NgClass, FormsModule, ReactiveFormsModule, IconComponent, NgStyle, MoneyPipe],
  selector: 'aux-investigator-forecast-source-select-item',
  template: `
    <div class="grid grid-cols-[1fr_15px]">
      <div
        #container
        class="border border-aux-gray-dark"
        [ngClass]="{
          'bg-aux-gray-light': control.value === value,
        }"
      >
        <div
          class="flex items-center justify-between border-b border-aux-gray-dark bg-aux-gray-light p-3"
        >
          <div class="flex flex-col">
            <div class="flex items-center">
              <input
                type="radio"
                class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                [formControl]="control"
                [value]="value"
              />
              <span class="ml-3 cursor-pointer font-bold" (click)="selectSource()">
                {{ label }}
              </span>
            </div>

            @if (avgPatientCost) {
              <span class="ml-[24px] text-sm italic text-aux-gray-darkest">
                Avg. Patient Cost: {{ avgPatientCost | money }}
              </span>
            }
          </div>
          @if (icon) {
            <aux-icon [name]="icon" />
          }
        </div>
        <div class="grid grid-cols-2 gap-y-3 p-3">
          <span>Forecast Total:</span>
          <span class="text-right">{{ forecastTotal | money }}</span>
          <span>Spend to Date:</span>
          <span class="text-right">{{ spendToDate | money }}</span>
        </div>
        <div class="ml-2 mr-2 h-1 border-b border-aux-gray-dark"></div>
        <div class="grid grid-cols-2 p-3 font-bold">
          <span>Remaining:</span>
          <span class="text-right">{{ remaining | money }}</span>
        </div>
      </div>

      @if (control.value !== value) {
        <div class="bg-white"></div>
      }

      @if (control.value === value) {
        <div
          class="absolute right-[66.6%] w-[20px] border-b border-t border-aux-gray-dark bg-aux-gray-light"
          [ngStyle]="{ height: container.offsetHeight + 'px' }"
        ></div>
      }
    </div>
  `,
})
export class InvestigatorForecastSourceSelectItemComponent {
  @Input() avgPatientCost?: number;
  @Input() control!: FormControl;
  @Input() forecastTotal?: number;
  @Input() icon?: AuxIconName;
  @Input() label!: string;
  @Input() remaining?: number;
  @Input() spendToDate?: number;
  @Input() value!: string;

  selectSource() {
    if (this.control.enabled) {
      this.control.setValue(this.value);
    }
  }
}
